/**
 * @fuegokit/tokens 0.10.3
 * Do not edit directly
 * Generated on Sat, 19 Aug 2023 14:12:06 GMT
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
  lineHeights: {
    default: 1.429,
    condensed: 1.143,
    condensedUltra: 1,
    relaxed: 1.714,
  },
  fontFamilies: {
    normal: "SF Pro Text",
    mono: "SF Mono",
  },
  fontStack: {
    normal: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
    mono: "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace",
    title: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
  },
  fontSizes: {
    "0": "10px",
    "1": "11px",
    "2": "12px",
    "3": "14px",
    "4": "16px",
    "5": "18px",
    "6": "20px",
    "7": "24px",
    "8": "28px",
    "9": "29px",
    "10": "35px",
    "11": "36px",
    "12": "47px",
    "13": "62px",
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extraLight: 200,
  },
  letterSpacing: {
    "0": "0px",
    "1": "-0.042px",
    "2": "-0.084px",
    "3": "-0.112px",
    "4": "-0.14px",
    "5": "-0.048px",
    "6": "-0.096px",
    "7": "-0.128px",
    "8": "-0.16px",
  },
  paragraphSpacing: {
    "0": "0px",
    "1": 10,
  },
  textCase: {
    none: "none",
    uppercase: "uppercase",
  },
  textDecoration: {
    none: "none",
  },
};
